import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-small-footer',
    templateUrl: './small-footer.component.html',
    styleUrls: ['./small-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmallFooterComponent implements OnInit {
  date = new Date();
  year = this.date.getFullYear();

  constructor() {}

  ngOnInit(): void {}
}
